// extracted by mini-css-extract-plugin
export default {"container":"Videos_container__OohoV","videos":"Videos_videos__OXfRp","video":"Videos_video__ZR6wQ"};